import React from "react";

import { HeaderSlot, PAGE_HEADER_ACTIONS_SLOT_ID } from "shared/ui/HeaderSlot";

// Кнопки страницы, живущие в шапке: сортировка, создание, синхронизация.
export const PageHeaderActions = ({ children }: { children: React.ReactNode }) => (
    <HeaderSlot slotId={PAGE_HEADER_ACTIONS_SLOT_ID}>{children}</HeaderSlot>
);
